<a href="https://uk.trustpilot.com/review/artsupplies.co.uk" target="_blank" class="flex items-end gap-2">
  <div class="-mb-[2px] text-gray-100 font-semibold">Excellent</div>
  <img src="/assets/trustpilot-badge-light.webp" alt="Trustpilot" class="h-6" />
</a>
